<div
    #selectBtn
    id="{{ id }}"
    class="special drop-down-toggle"
    [ngClass]="{'with-indicator': dropIndicator, 'is-modern': this.modern}"
    [attr.disabled]="disabled"
    (click)="onClick($event)"
>
    <ng-container [ngTemplateOutlet]="selectedTemplate"></ng-container>
</div>
